module.exports = __webpack_public_path__ + "3313889413eb2ce5772e06f81e5fb393.png";